import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";

export const NotificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setSsoId: (state, action) => {
      state.ssoId = action.payload;
    },
  },
});

